import React, { useState, useCallback, useMemo } from "react";
import { Box, Typography, Card, Button } from "@mui/material";
import { market } from "../../CommonPage/MarketFlow/TradeData";

export default function CoinSlider({
  coinData = [],
  coinData1 = [],
  imageUrl,
  title,
  subtitle,
  type,
  buttonImage,
  index,
  hovered,
  dynamicHeight,
}) {
  const [isHovered, setIsHovered] = useState(false);

  // Memoize data to prevent unnecessary re-renders
  const allData = useMemo(
    () => ({
      ...market,
    }),
    []
  );

  const category = title;
  const coinList = allData?.[category] || [];

  // Optimized hover handlers
  const handleMouseEnter = useCallback(() => {
    setIsHovered(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setIsHovered(false);
  }, []);

  // Memoize coin data arrays to prevent recreation
  const duplicatedCoinData = useMemo(
    () => [...coinData, ...coinData],
    [coinData]
  );
  const duplicatedCoinData1 = useMemo(
    () => [...coinData1, ...coinData1],
    [coinData1]
  );

  return (
    <Box onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <Box sx={{ p: 2 }}>
        <Box
          key={index}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          sx={{
            backgroundColor: "#edf7fb",
            borderRadius: 2,
            p: 0,
            mb: 4,
            padding:{xs:"15px 0px",md:"0px"},
            height: {
              xs: "100%",
              md: dynamicHeight,
            },
            // Optimized transitions
            transition:
              "background-image 0.2s ease-out, transform 0.2s ease-out",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            position: "relative",
            overflow: "hidden",
            backgroundImage: hovered ? `url(${imageUrl})` : "none",
            transform: hovered ? "translateY(-2px)" : "none",
            // Performance optimizations
            willChange: "transform, background-image",
            backfaceVisibility: "hidden",
          }}
        >
          {/* First Marquee Row */}
          <Box
            sx={{
              mt: {
                xs: 1,
                md:
                  type === "first"
                    ? "4rem !important"
                    : type === "second"
                    ? "1.8rem !important"
                    : type === "third"
                    ? "1.8rem !important"
                    : type === "fourth"
                    ? "4rem !important"
                    : type === "five"
                    ? "4rem !important"
                    : type === "six"
                    ? "1.8rem !important"
                    : "1rem",
                lg: 12,
              },
              overflow: "hidden",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                animation: "marqueeLeft 8s linear infinite",
                animationPlayState: isHovered ? "running" : "paused",
                willChange: "transform",
                "@keyframes marqueeLeft": {
                  "0%": { transform: "translateX(0%)" },
                  "100%": { transform: "translateX(-50%)" },
                },
              }}
            >
              {duplicatedCoinData.map((coin, i) => (
                <Box key={i} px={1}>
                  <Card
                    sx={{
                      p: 2,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      borderRadius: 3,
                      boxShadow: "none",
                      width: "200px",
                      flex: "0 0 auto",
                      cursor: "pointer",
                      // Optimized transitions
                      transition: "transform 0.2s ease-out",
                      willChange: "transform",
                      "&:hover": {
                        transform: "translateY(-1px)",
                        boxShadow: "none",
                      },
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {coin.image && (
                        <Box
                          component="img"
                          src={coin.image}
                          alt={coin.symbol}
                          sx={{
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                            mr: 1,
                            // Performance optimization for images
                            willChange: "auto",
                          }}
                        />
                      )}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "column",
                        }}
                      >
                        <Typography
                          variant="h6"
                          fontWeight="bold"
                          sx={{
                            textWrap: "nowrap",
                            textAlign: "start",
                          }}
                        >
                          {coin.symbol}
                        </Typography>
                        {/* <Typography
                          variant="body2"
                          sx={{
                            color: coin?.price < 0 ? "#FF7677" : "#00C381",
                            textAlign: "start",
                          }}
                        >
                          {coin.price}
                        </Typography> */}
                      </Box>
                    </Box>
                  </Card>
                </Box>
              ))}
            </Box>
          </Box>

          {/* Second Marquee Row */}
          <Box mt={3} sx={{ overflow: "hidden", width: "100%" }}>
            <Box
              sx={{
                display: "flex",
                animation: "marqueeRight 8s linear infinite",
                animationPlayState: isHovered ? "running" : "paused",
                willChange: "transform",
                "@keyframes marqueeRight": {
                  "0%": { transform: "translateX(-50%)" },
                  "100%": { transform: "translateX(0%)" },
                },
              }}
            >
              {duplicatedCoinData1.map((coin, i) => (
                <Box key={i} px={1}>
                  <Card
                    sx={{
                      p: 2,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      borderRadius: 3,
                      boxShadow: "none",
                      width: "200px",
                      flex: "0 0 auto",
                      cursor: "pointer",
                      // Optimized transitions
                      transition: "transform 0.2s ease-out",
                      willChange: "transform",
                      "&:hover": {
                        transform: "translateY(-1px)",
                        boxShadow: "none",
                      },
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {coin.image && (
                        <Box
                          component="img"
                          src={coin.image}
                          alt={coin.symbol}
                          sx={{
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                            mr: 1,
                            // Performance optimization for images
                            willChange: "auto",
                          }}
                        />
                      )}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "column",
                        }}
                      >
                        <Typography
                          variant="h6"
                          fontWeight="bold"
                          sx={{
                            textWrap: "nowrap",
                            textAlign: "start",
                          }}
                        >
                          {coin.symbol}
                        </Typography>
                        {/* <Typography
                          variant="body2"
                          sx={{
                            color: coin?.price < 0 ? "#FF7677" : "#00C381",
                            textAlign: "start",
                          }}
                        >
                          {coin.price}
                        </Typography> */}
                      </Box>
                    </Box>
                  </Card>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        {/* Bottom section with button and text */}
        <Box
          sx={{
            paddingLeft: "0.9rem",
            position: "relative",
            // Optimized transitions
            transition: "transform 0.2s ease-out",
            willChange: "transform",
          }}
        >
          <Button
            sx={{
              background: "#86b7fe17",
              padding: "5px 17px 4px 8px",
              // Optimized transitions
              transition: "background 0.2s ease-out, transform 0.2s ease-out",
              willChange: "transform, background",
              "&:hover": {
                background: "#86b7fe30",
                transform: "translateY(-1px)",
              },
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <img
              src={buttonImage}
              alt="logo"
              height="20px"
              width="20px"
              style={{
                objectFit: "contain",
                // Performance optimization for images
                willChange: "auto",
              }}
            />
            <Typography
              sx={{
                color: "#667085",
                fontSize: "15px",
                mt: "2px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                // textOverflow: "ellipsis",
              }}
            >
              {title ?? ""}
            </Typography>
          </Button>

          <Box
            mt={2}
            sx={{
              // Optimized transitions
              transition: "transform 0.2s ease-out",
              willChange: "transform",
              "&:hover": {
                transform: "translateY(-1px)",
              },
            }}
          >
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              {title ?? ""}
            </Typography>
            <Typography
              variant="h5"
              color="rgba(102, 112, 133, 1)"
              sx={{ marginLeft: { xs: "-15px", md: "0px" } }}
            >
              {subtitle ?? ""}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
